"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _base = _interopRequireDefault(require("./base"));
var _utils = require("../utils");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The ModelDerivative, is used to fetch model-related data.
 */
var ModelDerivative = /*#__PURE__*/function (_Base) {
  /**
   * Create the ModelDerivative instance.
   *
   * @param sdk - the SDK instance
   */
  function ModelDerivative(sdk) {
    (0, _classCallCheck2["default"])(this, ModelDerivative);
    return _callSuper(this, ModelDerivative, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(ModelDerivative, _Base);
  return (0, _createClass2["default"])(ModelDerivative, [{
    key: "getMetadata",
    value:
    /**
     * metadata
     */
    function getMetadata(bubbleUrn) {
      var guid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var url = '/designdata/' + _utils.Base64.encode(bubbleUrn) + '/metadata';
      if ((guid === null || guid === void 0 ? void 0 : guid.length) > 0) {
        url = url + '/' + guid;
      }
      return this.HttpService.mdV2.get(url);
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'MD';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = ModelDerivative;